<template>
    <b-form-group :label-cols-sm="labelColsSm" :label-cols-lg="labelColsLg" :description="description" :label="label + ':'" :label-for="id" label-class="fs-14 grey-color fw-700 d-flex align-items-baseline" :class="compact ? 'mb-0' : ''">
        <b-form-rating v-model="value" :variant="variant" :show-value="showValue" precision="2" no-border inline readonly class="pl-0 grey-color" />
    </b-form-group>
</template>

<script>
export default {
    name: 'text-row-rating',
    props: {
        label: {
            type: String,
            required: true
        },
        value: {
            type: Number,
            required: true
        },
        description: {
            type: String,
            default: ''
        },
        compact: {
            type: Boolean,
            default: false
        },
        labelColsLg: {
            default: 3
        },
        labelColsSm: {
            default: 4
        },
        showValue: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        id() {
            return 'text_row_rating_' + this._uid;
        },
        variant() {
            return this.value < 3 ? 'danger' : this.value < 4.5 ? 'warning' : 'success';
        }
    }
};
</script>
